







































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch} from 'vue-property-decorator';
import {Inject} from 'inversify-props';

import {CertificateDetails} from '@/model/system/certificate/certificateDetails';

import CertificateUpload from '@/components/System/Certificate/CertificateUpload.vue';
import CertificateGenerate from '@/components/System/Certificate/CertificateGenerate.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {CertificateGenerate, CertificateUpload},
})
export default class CertificateChange extends Mixins<BaseComponent>(BaseComponent) {
  private selectedTab: number = 0;

  @Prop()
  private certificate!: CertificateDetails;

  private certificateUpdated(certificate: CertificateDetails) {
    this.$emit('update:certificate', certificate);
  }
}
